/** @fileoverview Implements the hosted app sign-in call through Platform auth. */

import { json } from './platformAuth';

export type AppSignIn = {
  code: string;
  returnUrl: string;
};

/** Asks the gateway for a one-time sign-in code for the hosted app. */
export const requestAppSignIn = (address: string, signal?: AbortSignal) =>
  json<AppSignIn>(`/fabrik-apps/${encodeURIComponent(address)}/sign-in`, undefined, {
    method: 'POST',
    signal,
  });
